import React from 'react';
import PropTypes from 'prop-types';
import './PropertyCard.css';

const PropertyCard = ({ property, onSelect }) => {
    return (
        <div className="property-card" onClick={() => onSelect(property)} style={{ cursor: 'pointer' }}>
            <img src={property.image} alt={property.title} className="property-image" />
            <div className="property-details">
                <h2 className="property-title">{property.title}</h2>
                <p className="property-description">{property.description}</p>
                <p className="property-price">{property.price}</p>
                {/* Removed Link and button, now whole card is clickable */}
            </div>
        </div>
    );
};

PropertyCard.propTypes = {
    property: PropTypes.shape({
        id: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    }).isRequired,
    onSelect: PropTypes.func.isRequired,
};

export default PropertyCard;